"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
exports.initializeAirportFilterState = initializeAirportFilterState;
exports.initializeAllFiltersState = initializeAllFiltersState;
exports.initializeFilterState = initializeFilterState;
exports.initializeMaxStopFilterState = initializeMaxStopFilterState;
exports.initializeMultiSelectFilterState = initializeMultiSelectFilterState;
exports.initializePriceFilterState = initializePriceFilterState;
exports.initializeSubAirportFilterState = initializeSubAirportFilterState;
exports.initializeSubFilterState = initializeSubFilterState;
exports.initializeSubTimeFilterState = initializeSubTimeFilterState;
exports.initializeTimeFilterState = initializeTimeFilterState;
exports.initializeTimeSegments = initializeTimeSegments;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _each2 = _interopRequireDefault(require("lodash/each"));
var _fill2 = _interopRequireDefault(require("lodash/fill"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _constants = require("../constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function initializeAllFiltersState(filtersData, filterKeys) {
  if (filtersData === void 0) {
    filtersData = {};
  }
  if (filterKeys === void 0) {
    filterKeys = _constants.DEFAULT_FILTER_KEYS;
  }
  var filtersState = {};
  (0, _each2.default)(filterKeys, function (filterKey) {
    filtersState[filterKey] = initializeFilterState(filterKey, (0, _get2.default)(filtersData, filterKey));
  });
  return filtersState;
}
function initializeFilterState(filterKey, filterData) {
  switch (filterKey) {
    case 'airline':
      return initializeMultiSelectFilterState(filterData);
    case 'airport':
      return initializeAirportFilterState(filterData);
    case 'price':
      return initializePriceFilterState(filterData);
    case 'stop':
      return initializeMultiSelectFilterState(filterData);
    case 'maxStop':
      return initializeMaxStopFilterState(filterData);
    case 'departureTime':
      return initializeTimeFilterState(filterData);
    case 'arrivalTime':
      return initializeTimeFilterState(filterData);
    case 'insuranceOnly':
      return false;
    case 'hasBaggageOnly':
      return false;
    case 'isFlex':
      return false;
    default:
      return undefined;
  }
}
function initializeSubFilterState(_ref) {
  var filterKey = _ref.filterKey,
    filterData = _ref.filterData,
    filterState = _ref.filterState,
    filterPayload = _ref.filterPayload;
  switch (filterKey) {
    case 'airport':
      return initializeSubAirportFilterState({
        filterData: filterData,
        filterState: filterState,
        filterPayload: filterPayload
      });
    case 'departureTime':
      return initializeSubTimeFilterState({
        filterState: filterState,
        filterPayload: filterPayload
      });
    case 'arrivalTime':
      return initializeSubTimeFilterState({
        filterState: filterState,
        filterPayload: filterPayload
      });
    default:
      return undefined;
  }
}
function initializeMultiSelectFilterState(filterData) {
  if (filterData === void 0) {
    filterData = [];
  }
  return (0, _map2.default)(filterData, function (filterCode) {
    return {
      code: filterCode,
      selected: false
    };
  });
}
function initializeMaxStopFilterState(filterData) {
  if (filterData === void 0) {
    filterData = [];
  }
  return (0, _map2.default)(_constants.STOP_FILTER_CODES, function (code) {
    return {
      code: code,
      selected: false,
      isAvailable: (0, _includes2.default)(filterData, code)
    };
  });
}
function initializeAirportFilterState(filtersData) {
  if (filtersData === void 0) {
    filtersData = [];
  }
  return (0, _map2.default)(filtersData, function (legFilterData) {
    var origin = initializeMultiSelectFilterState(legFilterData.origin);
    var destination = initializeMultiSelectFilterState(legFilterData.destination);
    return {
      origin: origin,
      destination: destination
    };
  });
}
function initializeSubAirportFilterState(_ref2) {
  var filterData = _ref2.filterData,
    filterState = _ref2.filterState,
    filterPayload = _ref2.filterPayload;
  var type = filterPayload.type,
    index = filterPayload.index;
  return (0, _map2.default)(filterState, function (legFilterState, legIndex) {
    var _objectSpread2;
    if (index !== legIndex) {
      return legFilterState;
    }
    return _objectSpread(_objectSpread({}, legFilterState), {}, (_objectSpread2 = {}, _objectSpread2[type] = initializeMultiSelectFilterState((0, _get2.default)(filterData, index + "." + type)), _objectSpread2));
  });
}
function initializePriceFilterState(_temp) {
  var _ref3 = _temp === void 0 ? {} : _temp,
    min = _ref3.min,
    max = _ref3.max;
  if (!min && min !== 0 || !max && max !== 0) {
    return {};
  }
  return {
    min: min,
    max: max,
    from: min,
    to: max
  };
}
function initializeTimeSegments() {
  return (0, _map2.default)(_constants.TIME_FILTER_SEGMENTS, function (timeSegment) {
    return _objectSpread(_objectSpread({}, timeSegment), {}, {
      selected: false
    });
  });
}
function initializeTimeFilterState(_temp2) {
  var _ref4 = _temp2 === void 0 ? {} : _temp2,
    _ref4$legCount = _ref4.legCount,
    legCount = _ref4$legCount === void 0 ? 0 : _ref4$legCount;
  var timeSegments = initializeTimeSegments();
  return (0, _fill2.default)(Array(legCount), timeSegments);
}
function initializeSubTimeFilterState(_ref5) {
  var filterState = _ref5.filterState,
    filterPayload = _ref5.filterPayload;
  var index = filterPayload.index;
  return (0, _map2.default)(filterState, function (legFilterState, legIndex) {
    if (index !== legIndex) {
      return legFilterState;
    }
    return initializeTimeSegments();
  });
}
var _default = exports.default = initializeAllFiltersState;